import * as React from 'react'; 


export interface SpinnerProps{
    className?:string;
}

export interface SpinnerState{

}

export class Spinner extends React.Component<SpinnerProps, SpinnerState>{
    el:HTMLDivElement;
    constructor(p:SpinnerProps){
        super(p);
    }

    render(){
        let props = this.props, 
            state = this.state,
            cls = this.props.className || "";
        return (
            <div className="preloader-wrapper small active">
            <div className="spinner-layer spinner-blue-only">
              <div className="circle-clipper left">
                <div className="circle" />
              </div>
              <div className="gap-patch">
                <div className="circle" />
              </div>
              <div className="circle-clipper right">
                <div className="circle" />
              </div>
            </div>
          </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/Spinner/Spinner.tsx